module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_8003.ce00848b.png";